import useSWRMutation from 'swr/mutation'

import { apiGetBlobFetcher } from '@/common/api/fetcher'
import {
  DownloadFeatureListExcelVars,
  FeatureListApiPath
} from '@/common/api/params/featureList'
import { useShowToastIfMutationError } from '@/common/app/toast'

export const useDownloadFeatureListExcel = (onSuccess: (blob: Blob) => void) => {
  const showError = useShowToastIfMutationError()
  return useSWRMutation<Blob, Response, string, DownloadFeatureListExcelVars>(
    FeatureListApiPath.DOWNLOAD_FEATURE_LIST_EXCEL,
    apiGetBlobFetcher,
    { onSuccess, onError: showError }
  )
}
